import { ProviderConfigs } from '@rci/environment-loader';
import {
  environmentConfigurator as sharedEnvironmentConfigurator,
  GlobalAppConfig,
  GlobalAppConfigService,
} from '@rci/self-serve-shared';
import { PdoConfig, PdoConfigService } from '@rogers/self-serve-my-offers/pdo-config';

export function environmentConfigurator(env): ProviderConfigs {
  return [
    ...sharedEnvironmentConfigurator(env),
    {
      class: GlobalAppConfigService,
      config: {
        loadingTimeout: env.loadingTimeout,
        maxPdoOffersCount: env.maxPdoOffersCount,
        offersCacheLifetimeMinutes: env.offersCacheLifetimeMinutes,
        tempSuspensionMinRemainingDays: env.tempSuspensionMinRemainingDays,
        vaEnvironment: env.vaEnvironment,
      } as GlobalAppConfig,
    },
    {
      class: PdoConfigService,
      config: {
        ...env.pdoConfig,
      } as PdoConfig,
    },
  ];
}
